module.exports = __webpack_public_path__ + "img/11.502bb659.jpg";